import {
  type DatasetDataFreshnessStatus,
  type DatasetsDataFreshnessStatus,
} from '../DataFreshnessWidget.types';

export const DATA_FRESHNESS_BUTTON_ID = 'data-freshness-button';

export const getFreshnessStatusTextColor = (
  status: DatasetDataFreshnessStatus | DatasetsDataFreshnessStatus,
): string => {
  switch (status) {
    case 'old':
    case 'some_datasets_old':
    case 'all_datasets_old':
      return 'text-destructive';
    default:
      return 'text-success';
  }
};
